export { default } from "./settings-plates.native";
